import { RouteComponentProps } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import {
	IReactivateMembershipPageContent,
	ReactivateMembership,
} from '@ui/routes/Dashboard/Membership/ReactivateMembership';
import ErrorRoute from '@ui/routes/Error/ErrorRoute';

import useMemberInfo from '@hooks/useMemberInfo';
import { useMemberValidation } from '@hooks/useMemberValidation';

import { keysToCamel } from '@utils/butter';

interface MemberOnlyRouteProps extends RouteComponentProps {
	component: React.ElementType;
	path: string;
	includeErrorContainer?: boolean;
	allowFolxMembers?: boolean;
	[x: string]: any;
}

const MemberOnlyRoute = ({
	component: Component,
	path,
	location,
	includeErrorContainer = false,
	allowFolxMembers = false,
	...rest
}: MemberOnlyRouteProps) => {
	const { loaded: membershipLoaded, memberMetadata } = useMemberValidation();
	const { loading: memberInfoLoading, memberInfo } = useMemberInfo();

	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "mssp-generic-reactivate-membership-page" }) {
				heading
				description
				disclaimer
			}
		}
	`);

	if (!membershipLoaded || memberInfoLoading) {
		return <div>Loading...</div>;
	}

	const refinedContent: IReactivateMembershipPageContent = keysToCamel(
		pageContent
	) as IReactivateMembershipPageContent;

	if (
		!memberMetadata?.membership?.isMembershipInactive ||
		(allowFolxMembers && memberInfo?.email.endsWith('@folxhealth.com'))
	) {
		return <Component {...rest} />;
	} else {
		return includeErrorContainer ? (
			<ErrorRoute>
				<ReactivateMembership pageContent={refinedContent} path={path} />
			</ErrorRoute>
		) : (
			<ReactivateMembership pageContent={refinedContent} path={path} />
		);
	}
};

export default MemberOnlyRoute;
